import React from 'react';

import { useGetProfile, useGetLangLocale } from '../../globals';
import { useGetLocalization } from '../../hooks';
import { useGetStoreTillsQuery } from '../../redux/services/store/storeService';
import { ID_TILLS_STATUS_INFO } from '../../utils/dom-element-ids';
import { getDirection } from '../../utils/getDirection';
import { getTillStatusColorClassName } from '../../utils/getTillStatusColorClassName';
import { getTillStatusLocalization } from '../../utils/getTillStatusLocalization';
import { ErrorMessage, InformationModal, Loader, Table } from '../reusable';
import { GetMultipleCurrencyText } from '../reusable/MultipleCurrencyText';

function StoreTills() {
  const getLocalization = useGetLocalization();
  const getTillStatusLabel = getTillStatusLocalization({ getLocalization });
  const { storeId } = useGetProfile();
  const { userLang } = useGetLangLocale();
  const direction = getDirection(userLang);
  const {
    data: { tills } = {},
    error: { message: tillsError } = {},
    isFetching: isTillsFetching,
    isLoading: isTillsLoading,
  } = useGetStoreTillsQuery({ storeId });

  if (isTillsLoading || isTillsFetching) return <Loader />;

  return (
    <div dir={direction}>
      {tillsError ? (
        <ErrorMessage rawError={tillsError}>
          {getLocalization('msg.error-fetching-tills')}
        </ErrorMessage>
      ) : (
        <Table
          columns={[
            {
              header: getLocalization('lbl.till-number'),
              processor: ({ tillNumber }) => tillNumber,
              width: 2,
            },
            {
              header: getLocalization('lbl.default-float'),
              processor: ({ defaultFloat }) =>
                defaultFloat ? GetMultipleCurrencyText(defaultFloat) : GetMultipleCurrencyText(0),
              width: 2,
            },
            {
              header: getLocalization('lbl.current-float'),
              processor: ({ currentFloat }) =>
                currentFloat ? GetMultipleCurrencyText(currentFloat) : GetMultipleCurrencyText(0),
              width: 2,
            },
            {
              extraInfo: (
                <InformationModal
                  modalTitle={getLocalization('lbl.till-details-status')}
                  informationList={[
                    {
                      definition: getLocalization('lbl.active-definition'),
                    },
                    {
                      definition: getLocalization('lbl.closed-definition'),
                    },
                    {
                      definition: getLocalization('lbl.picked-up-definition'),
                    },
                  ]}
                  iconId={ID_TILLS_STATUS_INFO}
                />
              ),
              extraInfoClassName: 'ml2-sm',
              getClassName: getTillStatusColorClassName,
              header: getLocalization('lbl.status'),
              headerClassName: 'd-sm-iflx flx-jc-sm-c flx-ai-sm-c',
              processor: getTillStatusLabel,
              width: 2,
            },
            {
              header: getLocalization('lbl.workstation-number'),
              processor: ({ workstationNumber }) =>
                workstationNumber && workstationNumber > 0 ? workstationNumber : '-',
              width: 2,
            },
          ]}
          data={tills}
          itemsPerPage={tills.length}
          rowsAreOpenable={false}
          showPagination={false}
          title={getLocalization('lbl.tills-details')}
        />
      )}
    </div>
  );
}

export default StoreTills;
